<template>
  <div>
    <div class="header_wrap">
      <div style="width: 60%">
        <el-steps style="width: 100%" align-center :active="1">
          <el-step title="海运信息"></el-step>
          <el-step title="增值服务"></el-step>
          <el-step title="托运信息"></el-step>
          <el-step title="确认委托"></el-step>
          <el-step title="委托完成"></el-step>
        </el-steps>
      </div>
    </div>
    <!-- --------------------------------内容 -->
    <div class="center_wrap">
      <div class="wrap_l">
        <div style="display: flex; display: -webkit-flex; align-items: center">
          <img src="../../assets/style.png" alt="增值服务" />
          <p
            style="
              font-size: 20px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              margin-left: 10px;
            "
          >
            增值服务
          </p>
        </div>
        <div
          class="Item_list"
          v-for="(item, index) in formData.feeItemDTOS"
          :key="index"
        >
          <div style="width: 100%">
            <el-checkbox v-model="item.checked" @change="handleChange()">{{
              item.feeName
            }}</el-checkbox>
          </div>
          <div
            class="LR_center"
            style="width: 100%; float: left"
            v-show="item.checked"
          >
            <div
              class="count_center"
              style="padding: 25px 25px 0 25px; box-sizing: border-box"
            >
              <span style="float: left">{{ item.priceDesc }}</span>
              <div style="float: left; margin-left: 15px">
                <el-input-number
                  size="mini"
                  v-model="item.num"
                  @change="handleChange(item)"
                  :min="1"
                  :max="9999"
                ></el-input-number>
              </div>
            </div>

            <div style="padding: 25px 25px 0 25px; box-sizing: border-box">
              预估费用：{{ item.currency }}{{ item.amount }}
            </div>
          </div>
          <div
            v-if="item.remark && item.checked"
            style="float: right; color: #ccc; padding-right: 25px"
          >
            *{{ item.remark }}
          </div>
        </div>
        <div v-show="formData.feeItemDTOS.length == 0" style="padding: 20px">
          <el-alert
            :closable="false"
            title="该线路暂无增值服务"
            type="warning"
            description="该线路暂无增值服务，请点击下一步继续操作"
            show-icon
          >
          </el-alert>
        </div>
      </div>
      <div class="wrap_R" :class="auto_fixed ? 'auto_fixed' : ''">
        <p
          style="
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #343434;
          "
        >
          费用计算
        </p>
        <div class="OrderDetails">
          <div class="Item_Right animate__animated animate__bounceInRight">
            <p class="tit">运输费</p>
            <p
              class="coutText"
              v-for="(item, index) in FBATransmoney.goodsTypeFeeDTOS"
              :key="index"
            >
              <span class="littit">{{ item.goodsTypeName }}</span>
              <span class="fontString"
                >{{ item.currency }}{{ item.amount }}</span
              >
              <span style="margin-left: 10px">({{ item.calDesc }})</span>
            </p>
            <p class="coutText">
              <span class="littit">小计</span>
              <span class="fontString"
                >{{ FBATransmoney.currency }}{{ FBATransmoney.amount }}</span
              >
            </p>
          </div>
          <div
            class="Item_Right animate__animated animate__bounceInRight"
            v-show="THFdata.checked"
          >
            <p class="tit">提货费</p>
            <p class="coutText">
              <span class="littit">发货地上门提货</span>
              <span class="fontString"
                >{{ THFdata.currency }}{{ THFdata.amount }}</span
              >
              <span
                class="littit"
                style="float: left; width: 100%"
                v-if="THFdata.maxKilometer > 0"
                >({{ THFdata.minKilometer }}--{{
                  THFdata.maxKilometer
                }})公里</span
              >
            </p>
          </div>
          <div class="Item_Right" v-if="formData.totalExpense">
            <p class="tit">增值服务费</p>
            <div
              class="coutText animate__animated animate__bounceInRight"
              v-for="(item, index) in formData.feeItemDTOS"
              :key="index"
              v-show="item.checked"
            >
              <span class="littit">{{ item.feeName }}</span>
              <span class="fontString"
                >{{ item.currency }}{{ item.amount }}({{ item.calDesc }})</span
              >
            </div>
            <div
              class="coutText animate__animated animate__bounceInRight"
              style="color: #ff3030"
            >
              <span class="littit" style="color: #ff3030">小计:</span>
              <span class="fontString">{{ formData.totalExpense }}</span>
            </div>
          </div>
          <div class="Item_Right">
            <p class="coutText">
              <span class="littit">合计费用</span>
              <span
                v-for="(item, index) in this.newArray"
                :key="index"
                v-show="item.amount > 0"
              >
                <span
                  ><span class="fontString" v-show="item.currency != ''">{{
                    item.currency
                  }}</span>
                  <span
                    class="fontString"
                    v-show="item.amount > 0"
                    style="margin-left: 5px; margin-right: 5px"
                    >{{ item.amount }}</span
                  ></span
                >
                <span v-show="index == newArray.length - 1 ? false : true"
                  >+</span
                >
              </span>
            </p>
            <p class="coutText">
              <span class="littit">折合人民币</span>
              <span class="fontString">CNY {{ calculatePrice }}</span>
            </p>
          </div>
        </div>
        <div style="width: 100%; margin-top: 30px; float: left">
          <div style="width: 100%">
            <el-button style="width: 100%" @click="pathToback()"
              >上一步</el-button
            >
          </div>
          <div style="width: 100%; margin-top: 10px">
            <el-button
              @click="pathToNext()"
              style="width: 100%; background: #5ab53c; color: #ffffff"
              >下一步</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      moneytype: [],
      formData: {
        totalExpense: "",
        amount: 0,
        feeItemDTOS: [],
      },
      auto_fixed: false,
      showMoneythst: {
        //当前展示币种
        currencyTo: "",
        rate: "",
      },
      FBATransmoney: {
        checked: true,
        feeCode: "QBHYF",
        feeType: "Q",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "", //--单价
        cnyamount: "", //现有总价
        amount: "",
        piece: "1",
        price_unit: "",
        goodsTypeFeeDTOS: [],
      },
      msgFormSon: {},
      newTihuoarr: "", //需展示的提货地址
      todoordate: {},
      THFdata: {
        //提货费
        checked: false,
        feeCode: "THF",
        price: "",
        currency: "",
        cnyprice: "",
        cnycurrency: "",
        cnyamount: "",
        amount: "",
        piece: 1,
      },
    };
  },
  watch: {},
  computed: {
    calculatePrice() {
      //计算总费用
      let Totalmoney = 0; //总费用
      let FBATransmoney = 0; //运输费
      let THFmoney = 0; //提货费
      if (this.THFdata.checked) {
        //如果有提货费
        THFmoney = this.THFdata.cnyamount ? +this.THFdata.cnyamount : 0;
      }
      FBATransmoney = this.FBATransmoney.cnyamount
        ? +this.FBATransmoney.cnyamount
        : 0;
      Totalmoney = FBATransmoney + THFmoney + this.formData.amount;
      console.log(this.formData.amount);
      return Totalmoney.toFixed(2);
    },
    newArray() {
      //监听 币种
      let monetTypelist = []; //当前勾选的币种
      let totalMolist = []; //新对象
      let totalFeiyong = []; //当前勾选
      totalFeiyong.push(JSON.parse(JSON.stringify(this.FBATransmoney))); //海运费币种
      if (this.THFdata.checked) {
        totalFeiyong.push(JSON.parse(JSON.stringify(this.THFdata))); //提货费费币种
      }
      this.formData.feeItemDTOS.forEach((item) => {
        if (item.checked) {
          totalFeiyong.push(JSON.parse(JSON.stringify(item)));
        }
      });
      let newArray = totalFeiyong.reduce((total, cur, index) => {
        let hasValue = total.findIndex((current) => {
          return current.currency === cur.currency;
        });
        hasValue === -1 && total.push(cur);
        hasValue !== -1 &&
          (total[hasValue].amount = this.accAdd(
            total[hasValue].amount,
            cur.amount
          ));
        return total;
      }, []);
      return newArray;
    },
  },
  methods: {
    pathToNext() {
      let File = true;
      try {
        this.formData.feeItemDTOS.forEach((item) => {
          if (item.checked) {
            if (!item.num)
              throw this.$message({
                showClose: true,
                message: "请填写正确的价格",
                type: "error",
              });
          }
        });
      } catch (err) {
        File = false;
      }
      if (File) {
        sessionStorage.setItem("FeeLIst", JSON.stringify(this.formData)); //增值服务
        this.$router.push({
          name: "Fbaconsignment",
        });
      }
    },
    handleChange() {
      console.log(this.$route.query.PathCBM);
      //计算费用
      let that = this;
      let params = {};
      params = {
        customerId: this.sessionGetUserInfo()
          .customerid, //客户id
        inWarehouseId: JSON.parse(sessionStorage.getItem("fromFABck")).id,
        feeItemDTOS: this.formData.feeItemDTOS,
        cbm: this.$route.query.PathCBM,
        toWarehouseId: JSON.parse(sessionStorage.getItem("toFABck")).id,
        transportTypeCode: JSON.parse(
          sessionStorage.getItem("transportTypeCode")
        ),
      };
      this.axios
        .post(`/FBAfee/calFBAFeeItems`, params)
        .then((res) => {
          if (res.data.code == "200") {
            console.log(res.data.data);
            let Newarray = res.data.data.feeItemDTOS;
            that.formData.totalExpense = res.data.data.totalExpense;
            that.formData.amount = res.data.data.amount;
            this.formData.feeItemDTOS.forEach((item, index) => {
              if (Newarray[index].feeCode == item.feeCode) {
                item.amount = Newarray[index].amount;
                item.calDesc = Newarray[index].calDesc;
              }
            });
          } else {
          }
        })
        .catch((res) => {});
    },
    accAdd(arg1, arg2) {
      //加法精度
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },

    pathToback() {
      this.$router.go(-1);
    },
    getShowcount() {
      let that = this;
      let params = {};
      params = {
        customerId: this.sessionGetUserInfo().customerid, //客户id
        inWarehouseId: JSON.parse(sessionStorage.getItem("fromFABck")).id,
        toWarehouseId: JSON.parse(sessionStorage.getItem("toFABck")).id,
        transportTypeCode: JSON.parse(sessionStorage.getItem("transportTypeCode")),
      };
      this.axios
        .post(`/FBAfee/getFBAFeeItems`, params)
        .then((res) => {
          if (res.data.code == "200") {
            if (sessionStorage.getItem("FeeLIst")) {
              that.formData = JSON.parse(sessionStorage.getItem("FeeLIst"));
              this.handleChange();
            } else {
              that.formData.feeItemDTOS = res.data.datas;
            }
          } else {
          }
        })
        .catch((res) => {});
    },

    onScroll() {
      // 计算滚动的距离
      let scrolled =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 计算A区的高度
      let header_height = null;
      if (document.getElementsByClassName("wrap_R")[0]) {
        header_height = document.getElementsByClassName("wrap_R")[0]
          .offsetHeight;
      }
      if (scrolled >= 200) {
        this.auto_fixed = true;
      } else {
        this.auto_fixed = false;
      }
    },
  },
  created() {
    if (sessionStorage.getItem("FBATransmoney")) {
      //运输费
      this.FBATransmoney = JSON.parse(sessionStorage.getItem("FBATransmoney"));
    }
    if (sessionStorage.getItem("THFdata")) {
      //提货费
      this.THFdata = JSON.parse(sessionStorage.getItem("THFdata"));
    }
  },
  mounted() {
    this.getShowcount();
    this.$nextTick(function () {
      //监听滚动
      window.addEventListener("scroll", this.onScroll);
    });
  },
};
</script>
<style scoped>
.fontString {
  font-weight: bold;
}
.auto_fixed {
  position: fixed;
  top: 20px;
  margin-left: 880px;
}
/* 左右对齐 */
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
/* 垂直居中 */
.count_center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  /* flex-direction: column; */
}
.table_wrap >>> .el-dialog__body {
  padding: 0 15px !important;
}

.Item_Right {
  float: left;
  overflow-x: hidden;
}
.Item_Right .tit {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #343434;
}
.littit {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
}

.coutText {
  margin-top: 9px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  overflow-x: hidden;
}
.Item_Right {
  width: 100%;
  float: left;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}
.Iteminput {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  margin-bottom: 15px;
  color: #909399;
}
.center_wrap {
  width: 1200px;
  margin: 0 auto;
}
.Item_list {
  width: 100%;
  float: left;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}
.header_wrap {
  width: 100%;
  height: 121px;
  margin-top: 33px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.wrap_l {
  float: left;
  width: 875px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 35px;
  box-sizing: border-box;
}
.wrap_R {
  float: right;
  width: 320px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
}
.cangkutit {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  float: left;
}
/* table 滚动条 */
.OrderDetails {
  max-height: 500px;
  overflow: auto;
  overflow-x: hidden;
}
.OrderDetails::-webkit-scrollbar {
  width: 3px;
}
.OrderDetails::-webkit-scrollbar-thumb {
  border-radius: 2px;
  height: 50px;
  background: #409eff;
}
.OrderDetails::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/FBAorder/Fbaservice.vue